import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fullStop',
})
export class FullStopPipe implements PipeTransform {
  transform(value: string): string {
    if (typeof value !== 'string' || value === '') {
      return '';
    }
    if (value.endsWith('.')) {
      return value;
    }
    return `${value.trimEnd()}.`;
  }
}
